export const booleanSelect = [
  {
    id: true,
    name_en: "Yes",
    name_fr: "Oui",
  },
  { id: false, name_en: "No", name_fr: "Non" },
];

export const initialFiltersDriveInOut = {
  main: {
    ref: { filter: "", type: "search" },
    tailgating: { filter: ["all"], type: "select", values: [false] },
    dateTime: {
      startDate: null,
      endDate: null,
      type: "date",
    },
    zone: { filter: ["all"], type: "select" },
    status: { filter: ["all"], type: "select" },
    comments: { filter: "", type: "search" },
    riskLevel: { filter: ["all"], type: "select" },
    logType: { filter: ["all"], type: "select" },
    entryStatus: { filter: ["all"], type: "select" },
    processedBy: { filter: "", type: "search" },
    modifiedOn: {
      startDate: null,
      endDate: null,
      type: "date",
    },
    carrier: { filter: ["all"], type: "select" },
    active: { filter: [true], type: "select", values: [true, false] },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
  },
  driver: {
    name: { filter: "", type: "search" },
    tag: { filter: ["all"], type: "select" },
    threatLevel: { filter: ["all"], type: "select" },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
  truck: {
    privateVehicle: { filter: ["all"], type: "select", values: ["No"] },
    name: { filter: "", type: "search" },
    loaded: { filter: ["all"], type: "select" },
    po: { filter: "", type: "search" },
    bol: { filter: "", type: "search" },
    product: { filter: "", type: "search" },
    verified: {
      filter: ["all"],
      type: "select",
      values: ["Fuel Level", "Odometer", "Seal", "Temperature"],
    },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
  trailer1: {
    name: { filter: "", type: "search" },
    loaded: { filter: ["all"], type: "select", values: [] },
    po: { filter: "", type: "search" },
    bol: { filter: "", type: "search" },
    product: { filter: "", type: "search" },
    verified: { filter: ["all"], type: "select", values: [] },
    fuelLevel: { filter: ["all"], type: "select", values: [] },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
  trailer2: {
    name: { filter: "", type: "search" },
    loaded: { filter: ["all"], type: "select", values: [] },
    po: { filter: "", type: "search" },
    bol: { filter: "", type: "search" },
    product: { filter: "", type: "search" },
    verified: { filter: ["all"], type: "select", values: [] },
    fuelLevel: { filter: ["all"], type: "select", values: [] },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
};

// TODO: Redo this once actual columns have been defined for the trainInOut stuff
export const initialFiltersTrainInOut = {
  main: {
    ref: { filter: "", type: "search" },
    tailgating: { filter: ["all"], type: "select", values: [false] },
    dateTime: {
      startDate: null,
      endDate: null,
      type: "date",
    },
    zone: { filter: ["all"], type: "select" },
    status: { filter: ["all"], type: "select" },
    comments: { filter: "", type: "search" },
    riskLevel: { filter: ["all"], type: "select" },
    logType: { filter: ["all"], type: "select" },
    entryStatus: { filter: ["all"], type: "select" },
    processedBy: { filter: "", type: "search" },
    modifiedOn: {
      startDate: null,
      endDate: null,
      type: "date",
    },
    carrier: { filter: ["all"], type: "select" },
    active: { filter: [true], type: "select", values: [true, false] },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
  },
  driver: {
    name: { filter: "", type: "search" },
    tag: { filter: ["all"], type: "select" },
    threatLevel: { filter: ["all"], type: "select" },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
  truck: {
    privateVehicle: { filter: ["all"], type: "select", values: ["No"] },
    name: { filter: "", type: "search" },
    loaded: { filter: ["all"], type: "select" },
    po: { filter: "", type: "search" },
    bol: { filter: "", type: "search" },
    product: { filter: "", type: "search" },
    verified: {
      filter: ["all"],
      type: "select",
      values: ["Fuel Level", "Odometer", "Seal", "Temperature"],
    },
    fuelLevel: { filter: ["all"], type: "select" },
    odometer: { filter: "", type: "search" },
    seal: { filter: "", type: "search" },
    comments: { filter: "", type: "search" },
  },
};

export const initialFiltersWalkInOut = {
  main: {
    ref: { filter: "", type: "search" },
    dateTime: {
      startDate: null,
      endDate: null,
      type: "date",
    },
    zone: { filter: ["all"], type: "select" },
    status: { filter: ["all"], type: "select" },
    comments: { filter: "", type: "search" },
    riskLevel: { filter: ["all"], type: "select" },
    logType: { filter: ["all"], type: "select" },
    entryStatus: { filter: ["all"], type: "select" },
    processedBy: { filter: "", type: "search" },
    active: { filter: [true], type: "select", values: [true, false] },
    modifiedOn: {
      startDate: null,
      endDate: null,
      type: "date",
    },
  },
  human: {
    name: { filter: "", type: "search" },
    tag: { filter: ["all"], type: "select" },
    threatLevel: { filter: ["all"], type: "select" },
  },
};

export const columns = {
  summary_ref: "summary_ref",
  summary_date_time: "summary_date_time",
  summary_zone: "summary_zone",
  summary_status: "summary_status",
  summary_comments: "summary_comments",
  summary_risk_level: "summary_risk_level",
  summary_activity_type: "summary_activity_type",
  summary_authorization: "summary_authorization",
  summary_processed_by: "summary_processed_by",
  summary_processed_on: "summary_processed_on",
  summary_carrier: "summary_carrier",
  driver_name: "driver_name",
  driver_tag: "driver_tag",
  driver_threat: "driver_threat",
  vehicle_name: "vehicle_name",
  vehicle_private: "vehicle_private",
  vehicle_loaded: "vehicle_loaded",
  vehicle_po: "vehicle_po",
  vehicle_bol: "vehicle_bol",
  vehicle_product: "vehicle_product",
  vehicle_verified: "vehicle_verified",
  trailer1_name: "trailer1_name",
  trailer1_loaded: "trailer1_loaded",
  trailer1_po: "trailer1_po",
  trailer1_bol: "trailer1_bol",
  trailer1_product: "trailer1_product",
  trailer1_verified: "trailer1_verified",
  trailer2_name: "trailer2_name",
  trailer2_loaded: "trailer2_loaded",
  trailer2_po: "trailer2_po",
  trailer2_bol: "trailer2_bol",
  trailer2_product: "trailer2_product",
  trailer2_verified: "trailer2_verified",
  verified_verified: "verified_verified",
  verified_fuel_level: "verified_fuel_level",
  verified_odometer: "verified_odometer",
  verified_seal: "verified_seal",
  verified_temp_front: "verified_temp_front",
  verified_temp_middle: "verified_temp_middle",
  verified_temp_back: "verified_temp_back",
  verified_comments: "verified_comments",
};

const availablefilters = {
  entry_is_empty: "entry_is_empty",
  entry_is_not_empty: "entry_is_not_empty",
  number_is_equal_to: "number_is_equal_to",
  number_is_not_equal_to: "number_is_not_equal_to",
  number_is_greater_than: "number_is_greater_than",
  number_is_greater_than_or_equal_to: "number_is_greater_than_or_equal_to",
  number_is_less_than: "number_is_less_than",
  number_is_less_than_or_equal_to: "number_is_less_than_or_equal_to",
  number_is_between: "number_is_between",
  number_is_not_between: "number_is_not_between",
  this_hour: "this_hour",
  last_hour: "last_hour",
  past_n_hours: "past_n_hours",
  this_day: "this_day",
  last_day: "last_day",
  past_n_days: "past_n_days",
  this_week: "this_week",
  last_week: "last_week",
  past_n_weeks: "past_n_weeks",
  this_month: "this_month",
  last_month: "last_month",
  past_n_months: "past_n_months",
  this_quarter: "this_quarter",
  last_quarter: "last_quarter",
  past_n_quarters: "past_n_quarters",
  this_year: "this_year",
  last_year: "last_year",
  past_n_years: "past_n_years",
  date_is_exactly: "date_is_exactly",
  date_is_before: "date_is_before",
  date_is_after: "date_is_after",
  date_is_between: "date_is_between",
  text_contains: "text_contains",
  text_does_not_contains: "text_does_not_contains",
  text_starts_with: "text_starts_with",
  text_ends_with: "text_ends_with",
  text_is_exactly: "text_is_exactly",
  is_true: "is_true",
  is_not_true: "is_not_true",
};

export const filters = {
  number: [
    availablefilters.entry_is_empty,
    availablefilters.entry_is_not_empty,
    availablefilters.number_is_equal_to,
    availablefilters.number_is_not_equal_to,
    availablefilters.number_is_greater_than,
    availablefilters.number_is_greater_than_or_equal_to,
    availablefilters.number_is_less_than,
    availablefilters.number_is_less_than_or_equal_to,
    availablefilters.number_is_between,
    availablefilters.number_is_not_between,
  ],
  date_time: [
    availablefilters.entry_is_empty,
    availablefilters.entry_is_not_empty,
    availablefilters.this_hour,
    availablefilters.last_hour,
    availablefilters.past_n_hours,
    availablefilters.this_day,
    availablefilters.last_day,
    availablefilters.past_n_days,
    availablefilters.this_week,
    availablefilters.last_week,
    availablefilters.past_n_weeks,
    availablefilters.this_month,
    availablefilters.last_month,
    availablefilters.past_n_months,
    availablefilters.this_quarter,
    availablefilters.last_quarter,
    availablefilters.past_n_quarters,
    availablefilters.this_year,
    availablefilters.last_year,
    availablefilters.past_n_years,
    availablefilters.date_is_exactly,
    availablefilters.date_is_before,
    availablefilters.date_is_after,
    availablefilters.date_is_between,
  ],
  text: [
    availablefilters.entry_is_empty,
    availablefilters.entry_is_not_empty,
    availablefilters.text_contains,
    availablefilters.text_does_not_contains,
    availablefilters.text_starts_with,
    availablefilters.text_ends_with,
    availablefilters.text_is_exactly,
  ],
  boolean: [
    availablefilters.entry_is_empty,
    availablefilters.entry_is_not_empty,
    availablefilters.is_true,
    availablefilters.is_not_true,
  ],
  picklist: [
    availablefilters.entry_is_empty,
    availablefilters.entry_is_not_empty,
  ],
};
